module.exports = __webpack_public_path__ + "static/media/clooger-3.8a07a933.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/clooger-3.jpg
// module id = 372
// module chunks = 0